import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/lessonType/edit',   // 微传单模板编辑页面
      name: 'leafletEdit',
      component: () => import('../pages/leaflet/edit.vue')
    },
    {
      path: '/video/play',   // 微传单模板编辑页面
      name: 'video',
      component: () => import('../pages/XMVideo.vue')
    },
    {
      path: '/lessonType/index',  // 微传单模板预览页面
      name: 'leafletIndex',
      component: () => import('../pages/leaflet/index.vue')
    },
    {
      path: '/bargainType/edit',
      name: 'bargainTypeEdit',
      component: () => import('../pages/bargainType/edit.vue')
    },
    {
      path: '/bargainType/index',
      name: 'bargainTypeIndex',
      component: () => import('../pages/bargainType/index.vue')
    },
    {
      path: '/groupType/edit',
      name: 'groupTypeEdit',
      component: () => import('../pages/groupType/edit.vue')
    },
    {
      path: '/groupType/index',
      name: 'groupTypeIndex',
      component: () => import('../pages/groupType/index.vue')
    },
    {
      path: '/tyType/edit',  // 集赞模板
      name: 'tyTypeEdit',
      component: () => import('../pages/tyType/edit.vue')
    },
    {
      path: '/tyType/index',
      name: 'tyTypeIndex',
      component: () => import('../pages/tyType/index.vue')
    },
    {
      path: '/solitaireType/edit',
      name: 'solitaireTypeTypeEdit',
      component: () => import('../pages/solitaireType/edit.vue')
    },
    {
      path: '/solitaireType/index',
      name: 'solitaireTypeIndex',
      component: () => import('../pages/solitaireType/index.vue')
    },
    {
      path: '/gachaType/edit',
      name: 'gachaTypeEdit',
      component: () => import('../pages/gachaType/edit.vue')
    },
    {
      path: '/gachaType/index',
      name: 'gachaTypeIndex',
      component: () => import('../pages/gachaType/index.vue')
    },
    {
      path: '/distributeType/edit',
      name: 'distributeTypeEdit',
      component: () => import('../pages/distributeType/edit.vue')
    },
    {
      path: '/distributeType/index',
      name: 'distributeTypeIndex',
      component: () => import('../pages/distributeType/index.vue')
    },
    {
      path: '/show/detail/index',
      name: 'showDetailIndex',
      component: () => import('../pages/showDetail/index.vue')
    },
    { // 佣金记录
      path: '/show/distribution/commission',
      name: 'distributionCommission',
      component: () => import('../pages/showDetail/DistributionCommissionList.vue')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('../pages/Success.vue')
    },
    {
      path: '/reEditSuccess',
      name: 'reEditSuccess',
      component: () => import('../pages/ReEditSuccess.vue')
    },
    {
      path: '/notFound',
      name: 'notFound',
      component: () => import('../pages/NotFound.vue')
    },
    {
      path: '/poseType/index',
      name: 'poseTypeIndex',
      component: () => import('../pages/poseType/index.vue')
    },
    {
      path: '/poseType/edit',
      name: 'poseTypeEdit',
      component: () => import('../pages/poseType/edit.vue')
    }
  ]
})
